import { returnIfMinus1 } from '@/utils'
import { indexOf, pluck } from 'ramda'
import { Tab, TabPanelRef } from './Component'

const getTabIndex = (tabs: Tab[], activeKey: string): number =>
  returnIfMinus1(0, indexOf(activeKey, pluck('key', tabs)))

export const applyTabInkStyles = (
  tabPanelRef: TabPanelRef,
  tabs: Tab[],
  activeKey: string,
): void => {
  const tabInkElement = tabPanelRef.children.tabInk
  const tabContainerElement = tabPanelRef.children.tabWrapper
  const currentTabIndex = getTabIndex(tabs, activeKey)
  const currentTabElement = tabContainerElement?.children[
    currentTabIndex
  ] as HTMLElement

  if (currentTabElement) {
    const { offsetLeft, offsetWidth } = currentTabElement

    tabInkElement.style.width = `${offsetWidth}px`
    tabInkElement.style.left = `${offsetLeft}px`
  }
}
